import { QuotaErrorResponse } from '@/types/agents';

interface AxiosLikeError {
  response?: { status?: number; data?: unknown };
}

/** Detecta um erro de cota (HTTP 402) vindo do backend. */
export function isQuotaError(err: unknown): err is { response: { status: 402; data: QuotaErrorResponse } } {
  return (err as AxiosLikeError)?.response?.status === 402;
}

/**
 * Extrai a mensagem humanizada do payload 402. O backend (@quota_aware) já
 * manda `message` em PT-BR por scope; caímos num default só por segurança.
 */
export function quotaErrorMessage(data: unknown): string {
  const d = data as Partial<QuotaErrorResponse> | undefined;
  if (d && typeof d.message === 'string' && d.message) return d.message;
  return 'Cota excedida.';
}
